module.exports = __webpack_public_path__ + "media/images/default-user-bab0788bc644737dc0b2c4dbee8eaf77.svg";